export const THEME = {
  palette: {
    themePrimary: "#135C8A",
    themeLighterAlt: "#f2f7fa",
    themeLighter: "#cce0ec",
    themeLight: "#a3c6dc",
    themeTertiary: "#5994b9",
    themeSecondary: "#256c98",
    themeDarkAlt: "#11537c",
    themeDark: "#0f4669",
    themeDarker: "#0b344d",
    neutralLighterAlt: "#f8f8f8",
    neutralLighter: "#f4f4f4",
    neutralLight: "#eaeaea",
    neutralQuaternaryAlt: "#dadada",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c8c8",
    neutralTertiary: "#595959",
    neutralSecondary: "#373737",
    neutralPrimaryAlt: "#2f2f2f",
    neutralPrimary: "#000",
    neutralDark: "#151515",
    black: "#0b0b0b",
    white: "#fff",
  },
};
export const GS = {
  p8: {
    padding: 8,
  },
  bgWhite: {
    background: "#fff",
  },
  icon: { fontSize: 50, height: 50, width: 50, margin: "0 25px" },
  header: {
    fontSize: "28px",
    fontWeight: "400",
  },
};
